import {
  PAYMENT_METHOD_CASH_BUYER,
  PAYMENT_METHOD_GOVERNMENT_LOAN,
  PAYMENT_METHOD_LABELS,
  PAYMENT_METHOD_PANEL_BANKER,
  PAYMENT_METHOD_PREFERRED_BANKER,
  PAYMENT_METHOD_RENT_TO_OWN,
  PAYMENT_METHOD_STAFF_LOAN,
} from '../constants/paymentMethods';
import valueToText from './valueToText';

export const getFinanceSourceLabel = (type, financeSources) => {
  const idx = financeSources.findIndex(s => s.id === type);
  if (idx > -1) {
    return financeSources[idx].label;
  }
  // CPI-974 (D2/S1): label-only lookup, so it uses the label table rather than the option list -
  // Vietnam's 'bank_loan' renders as "Bank Loan" even when the tenant's rows are unseeded.
  return valueToText(PAYMENT_METHOD_LABELS, type);
};

export const getSourceOfFinanceValue = (value) => {
  if (value.includes(PAYMENT_METHOD_PANEL_BANKER)) return PAYMENT_METHOD_PANEL_BANKER;
  if (value.includes(PAYMENT_METHOD_PREFERRED_BANKER)) return PAYMENT_METHOD_PREFERRED_BANKER;
  if (value.includes(PAYMENT_METHOD_CASH_BUYER)) return PAYMENT_METHOD_CASH_BUYER;
  if (value.includes(PAYMENT_METHOD_GOVERNMENT_LOAN)) return PAYMENT_METHOD_GOVERNMENT_LOAN;
  if (value.includes(PAYMENT_METHOD_STAFF_LOAN)) return PAYMENT_METHOD_STAFF_LOAN;
  if (value.includes(PAYMENT_METHOD_RENT_TO_OWN)) return PAYMENT_METHOD_RENT_TO_OWN;
  return value;
};

export const getDefaultProjectSourceOfFinanceOptions = () => [
  PAYMENT_METHOD_PANEL_BANKER,
  PAYMENT_METHOD_PREFERRED_BANKER,
  PAYMENT_METHOD_CASH_BUYER,
  PAYMENT_METHOD_GOVERNMENT_LOAN,
  PAYMENT_METHOD_STAFF_LOAN,
  PAYMENT_METHOD_RENT_TO_OWN,
];



// WEBPACK FOOTER //
// ./src/utils/financeSource.js